const ClientGoals = (app) => {
  app
    .post(
      "/client-goals/add-new-goal",
      async ({ api, flash, req, res, locals }) => {
        const { body, query = {} } = req;
        const { proxyAthlete } = query;

        try {
          body.coachId = locals.activeUserToRequest._id;
          await api(`client-goals?proxyAthlete=${proxyAthlete}`, {
            method: "POST",
            body,
          });

          flash("success", "Goal successfully created");

          res.refreshWith(
            { modal: "", modalState: "" },
            { url: "back", hash: "#_" }
          );
        } catch (error) {
          flash("error", error.message);

          res.refreshWith(
            { "modal[type]": "add-client-goal", modalState: "" },
            { url: "back", hash: "#_" }
          );
        }
      }
    )
    .get(
      "/client-goals/delete-client-goal/:_id",
      async ({ req, res, flash, api }) => {
        const { params, query = {} } = req;
        const { proxyAthlete } = query;
        const { _id } = params;

        if (
          process.browser &&
          !confirm("Are you sure you want to delete this goal?")
        ) {
          return res.backDontScroll();
        }

        await api(`client-goals/${_id}?proxyAthlete=${proxyAthlete}`, {
          method: "DELETE",
        });
        flash("success", "Successfully deleted");

        res.backDontScroll();
      }
    )
    .post(
      "/client-goals/complete-client-goal/:_id",
      async ({ req, res, flash, api }) => {
        const { body, query = {}, params } = req;
        const { proxyAthlete } = query;
        const { _id } = params;
        if (
          process.browser &&
          !confirm(
            `Are you sure you want to mark this goal as ${
              body.completed ? "complete" : "incomplete"
            }?`
          )
        ) {
          return res.backDontScroll();
        }

        await api(`client-goals-complete?proxyAthlete=${proxyAthlete}`, {
          method: "PUT",
          body,
        });
        flash(
          "success",
          `Successfully marked as ${body.completed ? "complete" : "incomplete"}`
        );

        res.backDontScroll();
      }
    )
    .post(
      "/client-goals/edit-goal/:id?",
      async ({ api, flash, req, res, locals }) => {
        const { body, query = {}, params } = req;
        const { proxyAthlete } = query;
        const { id } = params;

        try {
          body.coachId = locals.activeUserToRequest._id;
          await api(`client-goals/${id}/?proxyAthlete=${proxyAthlete}`, {
            method: "PUT",
            body,
          });
          flash("success", "Goal successfully updated");

          res.refreshWith(
            { modal: "", modalState: "" },
            { url: "back", hash: "#_" }
          );
        } catch (error) {
          flash("error", error.message);

          res.refreshWith(
            { "modal[type]": "add-client-goal", modalState: "" },
            { url: "back", hash: "#_" }
          );
        }
      }
    );
};

export default ClientGoals;
